import React, { Suspense } from 'react';
import { observer, inject } from 'mobx-react';
import style from './style.module.css';
import Modal from 'react-modal';
import InputFields from './InputFields';
import { withTranslation } from 'react-i18next';

@inject(store => {
    const { myShopApiStore, ifaceMngr } = store;
    return { myShopApiStore, ifaceMngr };
})

@observer
class ValidSMSModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            code1: "", 
            code2: "", 
            code3: "", 
            code4: "",
            isMobile: window.innerWidth <= 850,
        }

        this.modalStyle = {
            content : {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                borderRadius: '20px',
                width: this.state.isMobile ? '100vw' : '30%',
                
            },
            overlay: {
                backgroundColor: "rgb(0, 0, 0, 0.65)",
                zIndex: 10
            }
        }
    }

    updateIsMobile = () => {
        this.setState({ isMobile: window.innerWidth <= 850 });
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateIsMobile); 
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateIsMobile);
    }

    handleConfirmCode = async () => {
        if(!this.canEnterCode()) return;

        const codeFields = ['code1', 'code2', 'code3', 'code4'];
        const code = codeFields.map(key => this.state[key].trim()).join('');

        this.setState(codeFields.reduce((acc, field) => {
            acc[field] = "";
            return acc;
        }, {}))

        if(code.length === 4 && await this.props.myShopApiStore.verifyPhone(code)){
            if(this.props.action  === 'Registration'){
                this.props.closeModal(false);
                this.props.ifaceMngr.setActiveTopMenu("ShopMenu");
                return;
            }
            this.props.closeModal();
            this.props.nextStep();
            // ////--->>>> // makes delivery order!
            // else if(this.props.action === 'Delivery'){
            //     this.props.openMapModal();
            // }
            // ////--->>>>
        }
    }

    handleCodeChange = (e) => {
        const { name, value } = e.target;

        if(!value.match(/\D/)){
            this.setState({[name]: value.slice(-1)});
        }
    }

    /**
     * The wait as text. The caps answer with anything from a minute to a whole
     * day, so the unit follows the size instead of counting out 3599 seconds.
     * The thresholds keep every count at two or more, so no singular is needed.
     */
    waitNotice = () => {
        const { smsRetryAfter } = this.props.myShopApiStore;
        const { t } = this.props;

        if(smsRetryAfter < 120) return t('TooManyRequests', {seconds: smsRetryAfter});
        if(smsRetryAfter < 7200) return t('TooManyRequestsMinutes', {minutes: Math.ceil(smsRetryAfter / 60)});

        return t('TooManyRequestsHours', {hours: Math.ceil(smsRetryAfter / 3600)});
    }

    /** True while an OTP abuse limit is still running. */
    isRateLimited = () => this.props.myShopApiStore.smsRetryAfter > 0;

    /**
     * A wait closes the code inputs only when there is no code to type into them.
     * A send refused while a code was already pending leaves one that still
     * works, and entering it is the customer's only way out of the wait.
     */
    canEnterCode = () => !this.isRateLimited() || this.props.myShopApiStore.smsCodePending;

    handleNewCodeClick = async () => {
        const { setWrongSMSCode, registerUser } = this.props.myShopApiStore;

        if(this.isRateLimited()) return;

        await registerUser();
        this.setState({code1: "", code2: "", code3: "", code4: ""});
        setWrongSMSCode(false);
    }

    render() {
        const { modalIsOpen, closeModal } = this.props;
        const { isWrongSMSCode, isBlockedUser } = this.props.myShopApiStore;
        const { t } = this.props;

        // A wait always closes "send me another code" - that request is the one
        // the limits exist for. Entering a code closes with it only when the
        // wait came with no code to enter. An API without these limits reports
        // no wait at all, and both of these stay open exactly as before.
        const isRateLimited = this.isRateLimited();
        const canEnterCode = !isBlockedUser && this.canEnterCode();

        return (
            <Modal style={this.modalStyle} isOpen={modalIsOpen}>
                <div className={style.ModalContainer}>
                    <form className={style.InputsForm} onSubmit={e => e.preventDefault()}>
                        <div className={style.ModalTitle}>
                            {canEnterCode && <span>{t('WeSentCodeToMobile')}</span>}
                            {canEnterCode && <br/>}
                            {canEnterCode && <span>{t('EnterCodeHere')}</span>}
                            {canEnterCode && isWrongSMSCode &&
                                <div className={style.WrongCodeText}>
                                    {t('CodeIsWrong')}
                                </div>
                            }
                            {isBlockedUser &&
                                <div className={style.BlockedUserText}>
                                    {t('NeedToBeRegistered')}
                                </div>
                            }
                        </div>
                        {!isBlockedUser && <div className={style.ModalInputs}>
                            {canEnterCode && <div className={style.Inputs}>
                                <InputFields isMobile={this.state.isMobile} handleChange={this.handleCodeChange} c1={this.state.code1} c2={this.state.code2} c3={this.state.code3} c4={this.state.code4}/>
                            </div>}

                            {/* The wait takes the place of the offer to send
                              * another code, since that is the request it holds
                              * back. With no inputs above it, it is the whole
                              * message. */}
                            <div className={style.NewCodeText}>
                            {isRateLimited &&
                                <span className={style.WaitText}>{this.waitNotice()}</span>
                            }
                            {!isRateLimited && isWrongSMSCode &&
                                <>
                                    <span>{t('GetNewCode')} </span>
                                    <span onClick={this.handleNewCodeClick}>{t('ClickHere')}</span>
                                </>
                            }
                            </div>
                        </div>}
                        <div className={style.ModalBtns}>
                            <button type='button' onClick={closeModal}>{t('Cancelation')}</button>
                            {canEnterCode && <button type='submit' onClick={this.handleConfirmCode}>
                                {t('allow')}
                            </button>}
                        </div>
                    </form>
                </div>
            </Modal>
        )
    }
}

export default withTranslation()(ValidSMSModal);